import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row, Card, CardGroup, Table, Spinner } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import ApiSupplier from "../../../core/api/api.supplier";
import SwalMessage from "../_Components/SwalMessage";
import { MenuItem } from "@mui/material";
import { NumericFormat } from "react-number-format";

export const ViewAndUpdateSupplier = ({ showModalSupplier, setShowModalSupplier, selectedSupplier }) => {
  const [supplier, setSupplier] = useState([]);
  const [supplierApprovalType, setSupplierApprovalType] = useState([]);
  const [historySupplierData, setHistorySupplierData] = useState([]);
  const [fileGet, setFileGet] = useState([]);
  const [showImage, setshowImage] = useState("");

  const [refresh, setRefresh] = useState(false);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
  } = useForm({ defaultValues: { id: 0 } });
  const handleClose = () => {
    setShowModalSupplier(false);
  };
  useEffect(() => {
    (async () => {
      try {
        if (selectedSupplier != 0) {
          const responseEnum = await ApiSupplier.getSupplierApprovalStatus();
          setSupplierApprovalType(responseEnum.data);

          const response = await ApiSupplier.getSupplierById(selectedSupplier);
          if (response.succeeded == true) {
            // مقدار اولیه
            setSupplier(response.data);
            setValue("companyName", response.data.companyName);
            setValue("companyNationalId", response.data.companyNationalId);
            setValue("licenseTypeS", response.data.licenseTypeS);
            setValue("cityName", response.data.cityName);
            setValue("cEOFirstName", response.data.ceoFirstName);
            setValue("cEOLastName", response.data.ceoLastName);
            setValue("cEOIdentityNumber", response.data.ceoIdentityNumber);
            setValue("status", response.data.supplierApprovalStatus);
            setValue("id", response.data.supplierId);
            setHistorySupplierData(response.data.statusJsonArray);
            setValue("phone", response.data.phone);
            setValue("cEOMobile", response.data.ceoMobile);
            setValue("supportMobile", response.data.supportMobile);
            setValue("riallBalance", response.data.riallBalance);

            let pp = response?.data?.files.map((item) => {

              let obj = {
                id: selectedSupplier,
                fileId: item,
                access: 1,
              };
              ApiSupplier.getFileOfFileManager(obj)
                .then((response) => {
                  let objectURL = URL.createObjectURL(new Blob([response]));
                  setFileGet((oldFileGet) => [...oldFileGet, objectURL]);
                })
                .catch((error) => {
                  console.error(`onRejected function called: ${error.message}`);
                });

              return;
            });
          }
        }
      } catch (error) {
        console.log("error :>> ", error);
      }
    })();
    return () => { };
  }, [refresh]);

  const onSubmit = async (data) => {
    try {
      const response = await ApiSupplier.updateSupplier({
        id: data.id,
        supplierApprovalStatus: data.status,
        discription: data.description,
      });
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      if (response.succeeded == true) setRefresh(!refresh);
    } catch (error) {
      console.log("error=", error);
    }
  };

  const viewImageFile = (urlImage) => (event) => {
    setshowImage(urlImage);
  };

  return (
    <div>
      <Modal centered size="lg" show={showImage != "" ? true : false} onHide={handleClose}>
        <Modal.Header closeButton>{/* <Modal.Title>ایجاد گروه تخفیف </Modal.Title> */}</Modal.Header>
        <Modal.Body></Modal.Body>
        <img src={showImage} width="80%" height="80%"></img>

        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            <CloseIcon /> بستن
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Start Modal */}
      {/* <Modal centered size='md' show={show} onHide={handleClose}> */}
      <Modal centered size="md" show={showModalSupplier} onHide={handleClose}>
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title> بررسی و تغییر وضعیت تامین کننده</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs="12">
                <Controller
                  name="companyName"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="نام شرکت"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                      disabled
                    />
                  )}
                />
              </Col>
              <Col xs="12">
                <Controller
                  name="companyNationalId"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="شناسه ملی شرکت"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                      disabled
                    />
                  )}
                />
              </Col>
              <Col xs="12">
                <Controller
                  name="licenseTypeS"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="مجوز شرکت"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                      disabled
                    />
                  )}
                />
              </Col>
              <Col xs="12">
                <Controller
                  name="cityName"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="شهر شرکت"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                      disabled
                    />
                  )}
                />
              </Col>
              <Col xs="12">
                <Controller
                  name="cEOFirstName"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="نام مدیر عامل"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                      disabled
                    />
                  )}
                />
              </Col>
              <Col xs="12">
                <Controller
                  name="cEOLastName"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="نام خانوادگی مدیر عامل"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                      disabled
                    />
                  )}
                />
              </Col>
              <Col xs="12">
                <Controller
                  name="cEOIdentityNumber"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="شماره ملی مدیر عامل"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                      disabled
                    />
                  )}
                />
              </Col>
              <Col xs="12">
                <Controller
                  name="cEOMobile"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="موبایل مدیر عامل"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                      disabled
                    />
                  )}
                />
              </Col>
              <Col xs="12">
                <Controller
                  name="phone"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="تلفن شرکت"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                      disabled
                    />
                  )}
                />
              </Col>
              <Col xs="12">
                <Controller
                  name="supportMobile"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="موبایل پشتیبانی "
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                      disabled
                    />
                  )}
                />
              </Col>
              <Col xs="12">
                <Controller
                  name="riallBalance"
                  control={control}
                  render={({ field: { value, onChange } }) => (
                    <NumericFormat
                      customInput={TextField}
                      label="موجودی کیف پول  "
                      type="search"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      onInput={onChange}
                      value={value || ""}
                      thousandSeparator=","
                      disabled
                      onKeyDown={(e) => {
                        if (e.key === "Escape") {
                          e.stopPropagation()
                        }
                      }}
                    />
                  )}
                />
              </Col>
              <Col xs="12">
                <Controller
                  name="phoneNumber"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="موبایل"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                    />
                  )}
                />
              </Col>
              <Col xs="12">
                <span>تصویر مدارک ارسال شده:</span>

                {fileGet?.length > 0 ? (
                  <Row className="d-flex flex-wrap justify-content-center mt-1 ">
                    {fileGet.map((item, index) => (
                      <span onClick={viewImageFile(item)} style={{ cursor: "pointer" }}>
                        فایل{++index} -{" "}
                      </span>

                      //console.log("itemitem ",item)
                    ))}
                  </Row>
                ) : (
                  <p>تصویر مدارک پیدا نشد .</p>
                )}
                <hr></hr>
              </Col>
              <Col xs="12">
                <Controller
                  name="status"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      select
                      label="وضعیت تامین کننده"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                      onChange={onChange}
                    >
                      <MenuItem key={99} value={undefined}>
                        {" "}
                        --{" "}
                      </MenuItem>
                      {supplierApprovalType?.map((item, index) => (
                        <MenuItem key={index} value={item.id}>
                          {item.title}{" "}
                        </MenuItem>
                      ))}
                      {/* <option value="select">----</option>
                                                    {status?.map((item, index) =>
                                                         <option   key={index} value={item.id} >{item.title}</option>
                                                    )} */}
                    </TextField>
                  )}
                />
              </Col>
              <Col xs="12" sm="12" lg="12">
                <Controller
                  name="description"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="توضیحات"
                      type="text"
                      rows={3}
                      multiline
                      variant="outlined"
                      margin="normal"
                      className="w-70"
                      // placeholder="توضیحات"
                      value={value || ""}
                      onInput={onChange}
                      sx={{
                        ".css-1b76txz-MuiInputBase-root-MuiOutlinedInput-root": {
                          padding: "8.5px 14px 8.5px 0px !important",
                        }
                      }}
                    />
                  )}
                />
              </Col>
            </Row>
            <Table striped hover responsive className="mt-2">
              <thead>
                <tr>
                  <th>#</th>
                  <th>وضعیت</th>
                  <th>توضیحات</th>
                  <th>توسط</th>
                  <th>تاریخ</th>
                </tr>
              </thead>
              <tbody>
                {historySupplierData?.map((item, index) => (
                  <tr>
                    <td>{index}</td>
                    <td>{item.supplierApprovalStatusS}</td>
                    <td>{item.discription}</td>
                    <td>{item.createdByS}</td>
                    <td>{item.createdS}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon />
              ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
